export const FLOUR_PROFILES = [
  {
    name: "Bread flour",
    aliases: ["strong flour", "high-gluten flour", "high protein flour"],
    activity: 1,
    starterActivity: 1,
    doughLift: 1.15,
    starterLift: 1.1,
    waterDemand: 1,
    doughScience: "High gluten-forming protein usually gives the strongest gas-holding network and the tallest wheat loaf.",
    starterScience: "A steady, predictable feed flour. A controlled study found bread flour favored a different lactic-acid-bacteria balance than all-purpose or whole wheat.",
    watch: "Strong structure can make jar height look impressive even when gas production is similar to a softer flour.",
  },
  {
    name: "All-purpose flour",
    aliases: ["plain flour", "white flour"],
    activity: 0.98,
    starterActivity: 0.98,
    doughLift: 1,
    starterLift: 1,
    waterDemand: 0.96,
    doughScience: "Moderate protein gives balanced extensibility and strength, usually with slightly less height tolerance than bread flour.",
    starterScience: "Reliable and mild, but refined flour contributes fewer bran minerals and enzymes than whole grain. Flour choice can still shift the bacterial community.",
    watch: "Often needs a little less water than bread or whole-grain flour.",
  },
  {
    name: "Whole wheat",
    aliases: ["wholemeal", "whole wheat flour"],
    activity: 1.11,
    starterActivity: 1.12,
    doughLift: 0.87,
    starterLift: 1.02,
    waterDemand: 1.12,
    doughScience: "Bran and germ add minerals, enzymes, and water demand. Fermentation often moves faster, while bran particles interrupt the gluten network and reduce maximum volume.",
    starterScience: "Often accelerates new or sluggish starters. In a 2026 controlled study, whole wheat selected a distinct bacterial balance with more Companilactobacillus.",
    watch: "Watch the dough sooner than the clock and allow time for bran to hydrate.",
  },
  {
    name: "Whole rye",
    aliases: ["dark rye", "wholemeal rye", "pumpernickel flour"],
    activity: 1.18,
    starterActivity: 1.2,
    doughLift: 0.5,
    starterLift: 0.82,
    waterDemand: 1.2,
    doughScience: "High amylase activity and water-binding arabinoxylans promote rapid acidification, but rye has little useful gluten. Structure comes mostly from starch and pentosans.",
    starterScience: "A nutrient-rich, fast-acidifying feed that commonly wakes a starter quickly. Its weak gluten means jar height can understate microbial activity.",
    watch: "Acidity is structurally important in high-rye dough because it helps control amylase; expect a dense, tacky matrix rather than wheat-style stretch.",
  },
  {
    name: "Medium rye",
    aliases: ["light rye", "rye flour"],
    activity: 1.14,
    starterActivity: 1.16,
    doughLift: 0.6,
    starterLift: 0.86,
    waterDemand: 1.13,
    doughScience: "Retains rye's active enzymes and pentosans with less bran than whole rye, so it ferments readily but still weakens wheat-style gas retention.",
    starterScience: "Usually gives a quick, aromatic feed with less mineral load than whole rye and more activity than refined white wheat.",
    watch: "Even modest rye percentages can shorten the schedule; visible dough strength will not behave like bread flour.",
  },
  {
    name: "Spelt",
    aliases: ["spelt flour"],
    activity: 1.07,
    starterActivity: 1.08,
    doughLift: 0.84,
    starterLift: 0.94,
    waterDemand: 0.96,
    doughScience: "Spelt gluten is extensible but comparatively fragile. Dough can expand quickly, then lose strength if mixed hard or fermented too far.",
    starterScience: "Spelt supports robust lactic-acid-bacteria growth and organic-acid production, but its softer matrix may show a less dramatic peak.",
    watch: "Use gentle development and shorten bulk before the dough becomes slack.",
  },
  {
    name: "Einkorn",
    aliases: ["einkorn flour"],
    activity: 1.07,
    starterActivity: 1.09,
    doughLift: 0.68,
    starterLift: 0.76,
    waterDemand: 0.93,
    doughScience: "Einkorn forms a weak, sticky gluten network with limited gas retention. It can ferment actively without producing a tall modern-wheat loaf.",
    starterScience: "Studies of ancient-wheat sourdoughs show strong microbial growth and acid accumulation. Visible rise is a poor stand-alone measure of activity.",
    watch: "Avoid chasing a bread-flour rise percentage; use bubbles, aroma, and expansion together.",
  },
  {
    name: "Emmer / farro",
    aliases: ["emmer", "farro", "emmer flour", "farro flour"],
    activity: 1.06,
    starterActivity: 1.08,
    doughLift: 0.76,
    starterLift: 0.84,
    waterDemand: 1.02,
    doughScience: "Emmer brings active whole-grain fermentation and nutty flavor, with weaker gas retention than modern bread wheat.",
    starterScience: "Ancient-wheat fermentation research found substantial bacterial growth and organic-acid production in emmer sourdough.",
    watch: "Blend with stronger wheat for taller free-form loaves, or use a pan when emmer is the majority flour.",
  },
  {
    name: "Durum / semolina",
    aliases: ["durum", "semolina", "durum flour", "semola rimacinata"],
    activity: 0.99,
    starterActivity: 1,
    doughLift: 0.9,
    starterLift: 0.86,
    waterDemand: 1.07,
    doughScience: "Durum is protein-rich, but its gluten is less elastic than bread wheat. Fine semola hydrates slowly and gives a firm, golden dough.",
    starterScience: "Supports a stable wheat starter, though coarse particles may make early rise look slower while hydration catches up.",
    watch: "Give it an early soak and judge strength after full hydration.",
  },
  {
    name: "Khorasan",
    aliases: ["kamut", "khorasan flour", "kamut flour"],
    activity: 1.04,
    starterActivity: 1.06,
    doughLift: 0.84,
    starterLift: 0.88,
    waterDemand: 1.04,
    doughScience: "Khorasan is high in protein but tends to form a more extensible, less elastic network than modern bread wheat.",
    starterScience: "As a whole ancient wheat, it supplies minerals and fermentable substrates that can support active starter growth.",
    watch: "Handle gently and avoid extending bulk solely to chase more height.",
  },
  {
    name: "Barley",
    aliases: ["barley flour", "whole barley"],
    activity: 1.05,
    starterActivity: 1.07,
    doughLift: 0.34,
    starterLift: 0.58,
    waterDemand: 1.19,
    doughScience: "Beta-glucan binds substantial water, while barley contributes no wheat-like gluten. It adds softness and flavor but lowers free-standing loaf volume.",
    starterScience: "Ferments readily and can support acid production, but a barley-heavy starter may bubble more than it rises.",
    watch: "Use as a minority flour unless the formula has a pan or another structural system.",
  },
  {
    name: "Oat flour",
    aliases: ["oat", "whole oat flour"],
    activity: 1.02,
    starterActivity: 1.04,
    doughLift: 0.24,
    starterLift: 0.48,
    waterDemand: 1.2,
    doughScience: "Oat beta-glucan raises viscosity and water demand but provides no gluten network, so higher percentages reduce loaf height.",
    starterScience: "Can acidify and bubble, yet its paste-like structure makes peak height a weak measure of yeast power.",
    watch: "Increase water gradually and pair with strong flour for an open loaf.",
  },
  {
    name: "Buckwheat",
    aliases: ["buckwheat flour"],
    activity: 1.1,
    starterActivity: 1.11,
    doughLift: 0.18,
    starterLift: 0.55,
    waterDemand: 1.14,
    doughScience: "Buckwheat is gluten-free and mineral-rich. Sourdough fermentation can be vigorous, but the dough needs wheat gluten or another binder to retain gas.",
    starterScience: "Often acidifies actively and develops a strong aroma; bubbling and acidity matter more than jar height.",
    watch: "Treat it as a flavor and fermentation flour, not a structural flour, unless building a dedicated gluten-free system.",
  },
];

export const FLOUR_DATABASE_CATEGORIES = [
  {
    id: "all-purpose",
    name: "All-purpose & medium-strength",
    shortName: "All-purpose",
    closestProfile: "All-purpose flour",
    summary: "Everyday white or lightly sifted flours that can handle cookies, buns, enriched dough, and some bread.",
    science: "Moderate protein gives flexibility. Higher-ash AP flours absorb more water and ferment a little faster than low-ash white AP.",
    records: [
      {
        id: "king-arthur-ap",
        brand: "King Arthur",
        name: "All-Purpose Flour",
        style: "Unbleached retail AP",
        protein: "11.7%",
        ash: "~0.50%",
        absorption: "Moderate-high · 60–64%",
        strength: "Medium-strong",
        sourceStatus: "Published protein / public product record",
        sourceUrl: "https://shop.kingarthurbaking.com/items/unbleached-all-purpose-flour",
        starterEffect: "Reliable maintenance flour with enough strength to show visible rise.",
        recipeEffect: "Acts almost like a light bread flour; good for pizza, buns, and everyday sourdough blends.",
        adjustment: "Hold back a little water when replacing high-extraction flour; add water if replacing softer AP.",
      },
      {
        id: "gold-medal-ap",
        brand: "Gold Medal",
        name: "All-Purpose Flour",
        style: "Bleached/enriched grocery AP",
        protein: "≈10.5%",
        ash: "Not listed",
        absorption: "Moderate · 58–62%",
        strength: "Medium",
        sourceStatus: "Public baking references",
        sourceUrl: "https://www.seriouseats.com/wheat-flour-guide",
        starterEffect: "Works for maintenance but may peak lower than stronger flour.",
        recipeEffect: "Softer crumb and gentler gluten; good for cakes, cookies, muffins, and tender sandwich loaves.",
        adjustment: "Use slightly less water than with bread flour and add folds if making free-form bread.",
      },
      {
        id: "cairnspring-sequoia",
        brand: "Cairnspring Mills",
        name: "Sequoia All-Purpose Flour",
        style: "Type 85 stone-milled AP",
        protein: "11–12%",
        ash: "Type 85 / higher ash",
        absorption: "High · +5% water",
        strength: "Medium-strong, flavorful",
        sourceStatus: "Public brand spec",
        sourceUrl: "https://cairnspring.com/products/sequoia-all-purpose-flour",
        starterEffect: "More mineral content can encourage activity; visible rise may be softer than white AP.",
        recipeEffect: "Strong enough for hearth loaves while still tender enough for pie crusts and scones.",
        adjustment: "Add about 5% more hydration compared with standard AP and watch bulk sooner.",
      },
      {
        id: "cairnspring-edison",
        brand: "Cairnspring Mills",
        name: "Organic Edison All-Purpose Flour",
        style: "Hard white spring wheat AP",
        protein: "10–11.5%",
        ash: "Type 85",
        absorption: "Moderate-high · +5% water",
        strength: "Medium / extensible",
        sourceStatus: "Public brand comparison",
        sourceUrl: "https://cairnspring.com/products/sequoia-all-purpose-flour",
        starterEffect: "Good activity with a milder white-wheat flavor profile.",
        recipeEffect: "Nutty, buttery, and softer than red-wheat AP; useful for rolls, focaccia, cakes, and pie crusts.",
        adjustment: "Treat as a thirsty AP flour; rest doughs before deciding they need more flour.",
      },
      {
        id: "costco-ap",
        brand: "Costco / Kirkland-style",
        name: "All-Purpose Flour",
        style: "Bulk AP flour",
        protein: "≈10–11.5%",
        ash: "Not listed",
        absorption: "Moderate · 58–63%",
        strength: "Medium",
        sourceStatus: "Regional/lot-dependent",
        sourceUrl: "https://www.seriouseats.com/wheat-flour-guide",
        starterEffect: "Works fine for maintenance feeds but can show less dramatic jar rise than strong bread flour.",
        recipeEffect: "Affordable base flour for soft loaves, pancakes, muffins, and blended sourdough formulas.",
        adjustment: "Hold back water when swapping in for bread flour, or blend with stronger flour for taller loaves.",
      },
    ],
  },
  {
    id: "bread-high-gluten",
    name: "Bread & high-gluten",
    shortName: "Bread",
    closestProfile: "Bread flour",
    summary: "High-protein flours for sourdough, bagels, pizza, baguettes, and loaves that need gas-holding strength.",
    science: "More gluten-forming protein generally improves elasticity and gas retention, but stronger flour can need more water and longer rest.",
    records: [
      {
        id: "king-arthur-bread",
        brand: "King Arthur",
        name: "Bread Flour",
        style: "Unbleached retail bread flour",
        protein: "12.7%",
        ash: "~0.50%",
        absorption: "High · 65–68%",
        strength: "Strong / elastic",
        sourceStatus: "Published protein / public product record",
        sourceUrl: "https://shop.kingarthurbaking.com/items/unbleached-bread-flour",
        starterEffect: "Predictable rise and clean wheat flavor; a dependable control flour for levain builds.",
        recipeEffect: "Builds gluten strength for open sourdough, pizza, bagels, and lean hearth loaves.",
        adjustment: "Start near normal hydration. If swapping from AP, add water gradually and expect more chew.",
      },
      {
        id: "king-arthur-high-gluten",
        brand: "King Arthur",
        name: "High-Gluten Flour",
        style: "Very strong retail/pro-style flour",
        protein: "≈14%",
        ash: "Not listed",
        absorption: "Very high · 68–72%",
        strength: "Very strong",
        sourceStatus: "Public product record / typical high-gluten range",
        sourceUrl: "https://shop.kingarthurbaking.com/items/high-gluten-flour",
        starterEffect: "Jar rise can look dramatic because the paste holds gas well.",
        recipeEffect: "Best for bagels, chewy pizza, and strengthening weaker blends; can be tough in tender goods.",
        adjustment: "Increase hydration and rest time; blend down if dough fights shaping.",
      },
      {
        id: "bobs-artisan-bread",
        brand: "Bob’s Red Mill",
        name: "Artisan Bread Flour",
        style: "Malted retail bread flour",
        protein: "≈13–14%",
        ash: "Not listed",
        absorption: "High · 65–70%",
        strength: "Strong / chewy",
        sourceStatus: "Nutrition-label protein + public product record",
        sourceUrl: "https://www.bobsredmill.com/product/artisan-bread-flour",
        starterEffect: "High protein and malted barley support strong gas retention and browning.",
        recipeEffect: "Great for sourdough, baguettes, pizza, pretzels, and bagels where chew and crust matter.",
        adjustment: "Hydrate well and give the dough rest time before deciding it needs more flour.",
      },
      {
        id: "central-artisan-bakers-craft-plus",
        brand: "Central Milling",
        name: "Organic Artisan Baker’s Craft Plus",
        style: "Malted organic bread flour",
        protein: "11.5%",
        ash: "0.60%",
        absorption: "Moderate-high · 62–66%",
        strength: "Balanced artisan",
        sourceStatus: "Public mill spec",
        sourceUrl: "https://centralmilling.com/product/organic-bread-flour-artisan-bakers-craft-plus/",
        starterEffect: "Steady feed flour; malt increases enzymatic activity and crust color in dough.",
        recipeEffect: "Balanced strength for baguettes, sourdough, pizza, laminated dough, and quick doughs.",
        adjustment: "Often needs less water than high-protein bread flour; build strength with folds.",
      },
      {
        id: "central-high-mountain",
        brand: "Central Milling",
        name: "Organic High Mountain Flour",
        style: "High-protein bread flour",
        protein: "13.5%",
        ash: "0.60%",
        absorption: "High · 66–70%",
        strength: "Very strong",
        sourceStatus: "Public mill spec",
        sourceUrl: "https://centralmilling.com/product/high-protein-bread-flour-organic-high-mountain/",
        starterEffect: "Can make levain height look strong because gluten holds gas.",
        recipeEffect: "Ideal for bagels, pan breads, focaccia, and strengthening sourdough blends.",
        adjustment: "Increase water slightly and avoid over-tight shaping if the dough becomes elastic.",
      },
      {
        id: "cairnspring-glacier-peak",
        brand: "Cairnspring Mills",
        name: "Glacier Peak Bread Flour",
        style: "Type 70 sifted bread flour",
        protein: "13–14%",
        ash: "Type 70",
        absorption: "High · 65–70%",
        strength: "Strong / lighter crumb",
        sourceStatus: "Public brand spec",
        sourceUrl: "https://cairnspring.com/products/glacier-peak-bread-flour",
        starterEffect: "Strong white-bread behavior with a bit more flavor than commodity white flour.",
        recipeEffect: "Great for pizza, sandwich bread, baguettes, croissants, and dinner rolls.",
        adjustment: "Treat as strong bread flour; give it rest time before correcting hydration.",
      },
      {
        id: "cairnspring-trailblazer",
        brand: "Cairnspring Mills",
        name: "Trailblazer Bread Flour",
        style: "Type 85 stone-milled bread flour",
        protein: "13–14.5%",
        ash: "Type 85 / higher ash",
        absorption: "Very high · +5% water",
        strength: "Strong with whole-grain extensibility",
        sourceStatus: "Public brand spec",
        sourceUrl: "https://cairnspring.com/products/trailblazer-bread-flour",
        starterEffect: "Mineral-rich extraction can wake a starter faster, while visible rise may look softer than white bread flour.",
        recipeEffect: "Adds flavor, color, and fermentation activity; bran/germ demand more water and gentler handling.",
        adjustment: "Add about 5% hydration and watch bulk sooner because higher extraction can ferment faster.",
      },
      {
        id: "cairnspring-expresso-bread",
        brand: "Cairnspring Mills",
        name: "Organic Expresso Bread Flour",
        style: "Type 85 rustic bread flour",
        protein: "13.8–15%",
        ash: "Type 85",
        absorption: "Very high · 68–75%",
        strength: "Very strong / rustic",
        sourceStatus: "Public brand comparison",
        sourceUrl: "https://cairnspring.com/products/trailblazer-bread-flour",
        starterEffect: "Fast-feeling fermentation and strong aroma from higher extraction and protein.",
        recipeEffect: "Rustic, spicy, caramel-colored crusts; useful for assertive sourdough and pizza blends.",
        adjustment: "Increase hydration, use gentler folds, and check dough before the clock says it is ready.",
      },
    ],
  },
  {
    id: "high-extraction",
    name: "High-extraction & sifted whole grain",
    shortName: "High-extraction",
    closestProfile: "Whole wheat",
    summary: "Partly sifted whole-grain flours such as Type 80/85/110 that keep more flavor, minerals, and enzymes than white flour.",
    science: "Higher ash means more bran/germ minerals and flavor. These flours usually absorb more water and can ferment faster while weakening gluten slightly.",
    records: [
      {
        id: "central-type-80",
        brand: "Central Milling",
        name: "Organic Type 80 Flour",
        style: "High-extraction bread flour",
        protein: "12.5%",
        ash: "0.80%",
        absorption: "High · 66–72%",
        strength: "Strong, flavorful",
        sourceStatus: "Public mill spec",
        sourceUrl: "https://centralmilling.com/product/organic-type-80-flour/",
        starterEffect: "More ash and enzymes can make feeds more aromatic and active.",
        recipeEffect: "Old-world flavor for sourdough, rustic European loaves, and chewy cookies.",
        adjustment: "Increase water gradually and let the bran hydrate before judging stiffness.",
      },
      {
        id: "cairnspring-trailblazer-type85",
        brand: "Cairnspring Mills",
        name: "Trailblazer Type 85",
        style: "Sifted hard red spring wheat",
        protein: "13–14.5%",
        ash: "Type 85",
        absorption: "Very high · +5% water",
        strength: "Strong but extensible",
        sourceStatus: "Public brand spec",
        sourceUrl: "https://cairnspring.com/products/trailblazer-bread-flour",
        starterEffect: "The extra bran/germ fraction can make starter aroma and acid development more obvious.",
        recipeEffect: "Flavorful base flour for country loaves and blends.",
        adjustment: "Use shorter mixing and gentler folds than pure white bread flour.",
      },
      {
        id: "central-type-110",
        brand: "Central Milling",
        name: "Organic Type 110 Flour",
        style: "High-ash sifted bread flour",
        protein: "Varies by crop",
        ash: "≈1.10%",
        absorption: "Very high · 70%+",
        strength: "Rustic / bran-limited",
        sourceStatus: "Public product family / typical type value",
        sourceUrl: "https://centralmilling.com/product/organic-type-80-flour/",
        starterEffect: "Often very active in feeds because of minerals and bran nutrients.",
        recipeEffect: "Brings deeper flavor and color but can reduce free-form loaf height.",
        adjustment: "Soak/autolyse longer and blend with bread flour when you want more lift.",
      },
    ],
  },
  {
    id: "whole-wheat",
    name: "Whole wheat & whole white wheat",
    shortName: "Whole wheat",
    closestProfile: "Whole wheat",
    summary: "Whole-kernel wheat flours with bran and germ intact. More nutrients and flavor, more water demand, less maximum loaf volume.",
    science: "Bran cuts gluten, germ adds fat and flavor, and minerals/enzyme activity can speed fermentation. Whole wheat often needs more water and earlier checks.",
    records: [
      {
        id: "king-arthur-whole-wheat",
        brand: "King Arthur",
        name: "Whole Wheat Flour",
        style: "Hard red whole wheat",
        protein: "≈14%",
        ash: "Whole grain",
        absorption: "Very high · 70–80%",
        strength: "High protein, bran-limited",
        sourceStatus: "Public product record / typical whole-wheat range",
        sourceUrl: "https://shop.kingarthurbaking.com/items/whole-wheat-flour",
        starterEffect: "Excellent for waking sluggish starters; visible rise may lag behind activity because bran weakens structure.",
        recipeEffect: "Nutty, hearty, and fast-fermenting; lowers open-crumb potential at high percentages.",
        adjustment: "Add water and give bran time to hydrate; consider 20–50% blends for lighter loaves.",
      },
      {
        id: "king-arthur-golden-whole-wheat",
        brand: "King Arthur",
        name: "Golden Whole Wheat",
        style: "Hard white whole wheat",
        protein: "≈13%",
        ash: "Whole grain",
        absorption: "High · 68–76%",
        strength: "Moderate-high",
        sourceStatus: "Public product record / whole-grain guidance",
        sourceUrl: "https://shop.kingarthurbaking.com/items/golden-whole-wheat-flour",
        starterEffect: "Feeds actively with a milder aroma than red whole wheat.",
        recipeEffect: "Whole-grain nutrition with lighter color and gentler flavor.",
        adjustment: "Use like whole wheat, but it can hide more easily in customer-friendly loaves.",
      },
      {
        id: "bobs-whole-wheat",
        brand: "Bob’s Red Mill",
        name: "Whole Wheat Flour",
        style: "Stone-ground whole wheat",
        protein: "≈13–14%",
        ash: "Whole grain",
        absorption: "Very high · 70–80%",
        strength: "High protein, bran-limited",
        sourceStatus: "Public product/nutrition record",
        sourceUrl: "https://www.bobsredmill.com/product/whole-wheat-flour",
        starterEffect: "A useful boost flour for feeds and young starters.",
        recipeEffect: "Robust flavor and fast fermentation; can tighten and darken crumb.",
        adjustment: "Autolyse longer and add water after the first rest if needed.",
      },
      {
        id: "central-hi-pro-whole-wheat",
        brand: "Central Milling",
        name: "Organic Whole Wheat Hi-Pro Fine",
        style: "Fine high-protein whole wheat",
        protein: "13.5%",
        ash: "1.60%",
        absorption: "Very high · 72–82%",
        strength: "High protein, whole-grain",
        sourceStatus: "Public mill spec",
        sourceUrl: "https://centralmilling.com/product/high-protein-100-whole-wheat-flour-hi-pro-fine/",
        starterEffect: "Strong feed flour with substantial mineral load; good for starter vitality.",
        recipeEffect: "Designed for 100% whole-wheat artisan and pan breads.",
        adjustment: "Use warm water, full hydration time, and avoid over-proofing.",
      },
      {
        id: "cairnspring-whole-grain-expresso",
        brand: "Cairnspring Mills",
        name: "Organic Whole Grain Expresso",
        style: "Unsifted hard red spring wheat",
        protein: "13.5–14.5%",
        ash: "Whole grain / Type 70 family",
        absorption: "Very high · 72–82%",
        strength: "Strong but bran-limited",
        sourceStatus: "Public brand comparison",
        sourceUrl: "https://cairnspring.com/products/trailblazer-bread-flour",
        starterEffect: "Likely fast and aromatic in feed builds.",
        recipeEffect: "Whole-grain version of their bread flour for hearty loaves, rolls, and pancakes.",
        adjustment: "Blend with sifted bread flour when you want volume plus whole-grain flavor.",
      },
    ],
  },
  {
    id: "rye",
    name: "Rye flours",
    shortName: "Rye",
    closestProfile: "Whole rye",
    summary: "Light, medium, dark, and whole rye flours. Rye ferments vigorously but does not build wheat-style gluten structure.",
    science: "Rye relies on starches and pentosans rather than strong gluten. It loves acidity, absorbs water heavily, and can make starters very active.",
    records: [
      {
        id: "central-dark-rye",
        brand: "Central Milling",
        name: "Organic Whole Dark Rye Flour",
        style: "Whole rye flour",
        closestProfile: "Whole rye",
        protein: "10.9%",
        ash: "1.60%",
        absorption: "Very high · sticky gel",
        strength: "Low gluten strength",
        sourceStatus: "Public mill spec",
        sourceUrl: "https://centralmilling.com/product/organic-whole-dark-rye-flour/",
        starterEffect: "Fantastic for sourdough starter because of high nutrient content and fast acidification.",
        recipeEffect: "Deep flavor and moisture retention; needs wheat flour or rye-specific methods for volume.",
        adjustment: "Do not judge by stretch. Use acidity, aroma, and paste structure.",
      },
      {
        id: "bobs-dark-rye",
        brand: "Bob’s Red Mill",
        name: "Dark Rye Flour",
        style: "Whole/dark rye retail flour",
        closestProfile: "Whole rye",
        protein: "Nutrition-label range",
        ash: "Not listed",
        absorption: "Very high · sticky gel",
        strength: "Low gluten strength",
        sourceStatus: "Public product/nutrition record",
        sourceUrl: "https://www.bobsredmill.com/product/dark-rye-flour",
        starterEffect: "Excellent small-percentage feed boost for sluggish starters.",
        recipeEffect: "Strong rye flavor, darker color, and tender crumb in mixed loaves.",
        adjustment: "Use as 5–30% in wheat loaves unless building a rye-specific formula.",
      },
      {
        id: "king-arthur-medium-rye",
        brand: "King Arthur",
        name: "Organic Medium Rye Flour",
        style: "Medium rye",
        closestProfile: "Medium rye",
        protein: "Typical rye range",
        ash: "Medium rye",
        absorption: "High · paste-forming",
        strength: "Low gluten strength",
        sourceStatus: "Public product record",
        sourceUrl: "https://shop.kingarthurbaking.com/items/organic-medium-rye",
        starterEffect: "Adds quick aroma and acid without as much bran as whole rye.",
        recipeEffect: "Good deli rye and country-loaf blend flour.",
        adjustment: "Expect earlier fermentation and less extensible dough.",
      },
    ],
  },
  {
    id: "ancient-wheat",
    name: "Ancient wheat & heritage grains",
    shortName: "Ancient",
    closestProfile: "Spelt",
    summary: "Spelt, einkorn, emmer, khorasan, and similar grains. Often flavorful and active but structurally different from modern bread wheat.",
    science: "Many ancient grains ferment readily but form weaker or more extensible gluten. Visible rise can understate microbial activity.",
    records: [
      {
        id: "bobs-spelt",
        brand: "Bob’s Red Mill",
        name: "Spelt Flour",
        style: "Whole spelt",
        closestProfile: "Spelt",
        protein: "Nutrition-label range",
        ash: "Whole grain",
        absorption: "Moderate-high · 64–70%",
        strength: "Extensible / fragile",
        sourceStatus: "Public product/nutrition record",
        sourceUrl: "https://www.bobsredmill.com/product/spelt-flour",
        starterEffect: "Supports active fermentation with a sweet, nutty aroma.",
        recipeEffect: "Soft, extensible dough that can over-relax if pushed too long.",
        adjustment: "Mix gently, shorten bulk, and avoid chasing maximum height.",
      },
      {
        id: "central-whole-spelt",
        brand: "Central Milling",
        name: "Organic Whole Spelt Flour",
        style: "Fine whole spelt",
        closestProfile: "Spelt",
        protein: "Mill spec varies",
        ash: "Whole grain",
        absorption: "Moderate-high · 64–72%",
        strength: "Extensible / fragile",
        sourceStatus: "Public product record",
        sourceUrl: "https://centralmilling.com/product/organic-whole-spelt-flour/",
        starterEffect: "Active, aromatic, and softer-rising than bread flour.",
        recipeEffect: "Good for blended sourdough, pan loaves, muffins, and crackers.",
        adjustment: "Use folds gently and shape earlier than modern bread wheat.",
      },
      {
        id: "jovial-einkorn",
        brand: "Jovial-style",
        name: "Whole Einkorn Flour",
        style: "Ancient whole wheat",
        closestProfile: "Einkorn",
        protein: "≈14–16% label range",
        ash: "Whole grain",
        absorption: "Lower-moderate but sticky",
        strength: "Very weak / sticky",
        sourceStatus: "Public nutrition-label style record",
        sourceUrl: "https://jovialfoods.com/einkorn/",
        starterEffect: "Can bubble and acidify strongly without tall jar rise.",
        recipeEffect: "Tender, golden, and sticky; not built for tall free-form loaves by itself.",
        adjustment: "Reduce hydration, avoid overmixing, and use pans or blends.",
      },
      {
        id: "emmer-farro",
        brand: "Heritage mill",
        name: "Emmer / Farro Flour",
        style: "Ancient whole wheat",
        closestProfile: "Emmer / farro",
        protein: "Varies by grower",
        ash: "Whole grain",
        absorption: "High · 66–74%",
        strength: "Moderate-low",
        sourceStatus: "Typical heritage grain record",
        sourceUrl: "https://www.seriouseats.com/wheat-flour-guide",
        starterEffect: "Active and aromatic but not always tall-rising.",
        recipeEffect: "Nutty flavor; best blended or baked in pans at high percentages.",
        adjustment: "Blend with bread flour if the loaf needs height.",
      },
      {
        id: "khorasan-kamut",
        brand: "KAMUT-style",
        name: "Khorasan Flour",
        style: "Ancient wheat",
        closestProfile: "Khorasan",
        protein: "High, crop-dependent",
        ash: "Whole grain if unsifted",
        absorption: "High · 66–74%",
        strength: "Extensible / less elastic",
        sourceStatus: "Typical ancient wheat record",
        sourceUrl: "https://www.seriouseats.com/wheat-flour-guide",
        starterEffect: "Good mineral load for feeds; visible rise may be moderate.",
        recipeEffect: "Buttery color and flavor with a softer gluten network.",
        adjustment: "Use gentle development and avoid long warm over-proofing.",
      },
    ],
  },
  {
    id: "pizza-pasta-durum",
    name: "Pizza, pasta, durum & 00",
    shortName: "Pizza/Pasta",
    closestProfile: "Durum / semolina",
    summary: "Finely milled 00 flours, durum, and semolina for pizza, pasta, focaccia, and golden doughs.",
    science: "00 refers to grind/extraction, not protein. Durum proteins are high but less elastic; semolina hydrates slowly and gives golden color.",
    records: [
      {
        id: "caputo-pizzeria-00",
        brand: "Caputo",
        name: "Pizzeria 00 Flour",
        style: "Italian pizza flour",
        closestProfile: "Bread flour",
        protein: "≈12.5%",
        ash: "Tipo 00",
        absorption: "Moderate · lower than US bread flour",
        strength: "Extensible pizza strength",
        sourceStatus: "Public baking reference",
        sourceUrl: "https://www.seriouseats.com/the-pizza-lab-on-flour-foams-and-dough",
        starterEffect: "Fine flour feeds smoothly but lacks whole-grain mineral boost.",
        recipeEffect: "Classic Neapolitan texture: extensible, tender, and blistering at high heat.",
        adjustment: "Use lower hydration than strong bread flour and avoid over-flouring.",
      },
      {
        id: "central-type-00",
        brand: "Central Milling",
        name: "Organic Type 00 Normal",
        style: "Fine pizza/pasta flour",
        closestProfile: "All-purpose flour",
        protein: "Mill spec varies",
        ash: "Tipo 00",
        absorption: "Moderate",
        strength: "Extensible",
        sourceStatus: "Public product record",
        sourceUrl: "https://centralmilling.com/product/type-00-normal/",
        starterEffect: "Neutral feed flour; best for texture rather than starter boost.",
        recipeEffect: "Fine texture for pizza, pasta, focaccia, and soft doughs.",
        adjustment: "Use pizza-style hydration and long rest for extensibility.",
      },
      {
        id: "bobs-semolina",
        brand: "Bob’s Red Mill",
        name: "Semolina Flour",
        style: "Durum wheat semolina",
        closestProfile: "Durum / semolina",
        protein: "Nutrition-label range",
        ash: "Not listed",
        absorption: "High but slow",
        strength: "Firm / less elastic",
        sourceStatus: "Public product/nutrition record",
        sourceUrl: "https://www.bobsredmill.com/product/semolina-flour",
        starterEffect: "Hydrates slowly; starter rise can lag at first.",
        recipeEffect: "Golden color, nutty bite, pasta texture, and firm pizza blends.",
        adjustment: "Soak early or extend autolyse before judging dough feel.",
      },
      {
        id: "king-arthur-semolina",
        brand: "King Arthur",
        name: "Semolina Flour",
        style: "Durum semolina",
        closestProfile: "Durum / semolina",
        protein: "Typical durum range",
        ash: "Not listed",
        absorption: "High but slow",
        strength: "Firm / less elastic",
        sourceStatus: "Public product record",
        sourceUrl: "https://shop.kingarthurbaking.com/items/semolina-flour",
        starterEffect: "Best as a blend flour; coarse particles hydrate gradually.",
        recipeEffect: "Improves color and bite in pasta, pizza, and seeded loaves.",
        adjustment: "Blend 5–30% into bread flour unless designing a durum formula.",
      },
    ],
  },
  {
    id: "soft-wheat",
    name: "Pastry, cake & soft wheat",
    shortName: "Soft wheat",
    closestProfile: "All-purpose flour",
    summary: "Lower-protein flours for cakes, biscuits, pastries, scones, and tender crumb work.",
    science: "Lower protein means less gluten formation. These flours are usually poor choices for tall sourdough unless blended with stronger flour.",
    records: [
      {
        id: "king-arthur-cake",
        brand: "King Arthur",
        name: "Cake Flour",
        style: "Low-protein cake flour",
        protein: "≈8%",
        ash: "Low",
        absorption: "Low-moderate",
        strength: "Weak / tender",
        sourceStatus: "Public product record / typical cake range",
        sourceUrl: "https://shop.kingarthurbaking.com/items/cake-flour",
        starterEffect: "Not ideal for starter strength; visible rise is weak.",
        recipeEffect: "Tender cake crumb and fine texture.",
        adjustment: "Do not use alone for bread; blend only for tenderness.",
      },
      {
        id: "swans-down-cake",
        brand: "Swans Down",
        name: "Cake Flour",
        style: "Bleached soft wheat cake flour",
        protein: "≈7–8%",
        ash: "Low",
        absorption: "Low",
        strength: "Very weak / tender",
        sourceStatus: "Typical public cake-flour range",
        sourceUrl: "https://www.seriouseats.com/wheat-flour-guide",
        starterEffect: "Poor structure for starter rise.",
        recipeEffect: "Excellent for high-ratio cakes and fine crumb.",
        adjustment: "Keep it out of sourdough unless using a tiny tenderizing percentage.",
      },
      {
        id: "white-lily-ap",
        brand: "White Lily",
        name: "All-Purpose Flour",
        style: "Soft wheat AP",
        protein: "≈9%",
        ash: "Low",
        absorption: "Low-moderate",
        strength: "Soft / biscuit-style",
        sourceStatus: "Public baking reference",
        sourceUrl: "https://www.seriouseats.com/wheat-flour-guide",
        starterEffect: "Weak rise compared with hard-wheat AP.",
        recipeEffect: "Great for biscuits and tender pastry; not ideal for open sourdough.",
        adjustment: "Use less water and add bread flour for structure.",
      },
      {
        id: "king-arthur-pastry",
        brand: "King Arthur",
        name: "Pastry Flour",
        style: "Soft wheat pastry flour",
        protein: "≈8–9%",
        ash: "Low",
        absorption: "Low-moderate",
        strength: "Weak / tender",
        sourceStatus: "Public product record / typical pastry range",
        sourceUrl: "https://shop.kingarthurbaking.com/items/pastry-flour",
        starterEffect: "Fine for sweet stiff levains only when blended; low jar strength.",
        recipeEffect: "Tender pie crust, cookies, biscuits, and scones.",
        adjustment: "Blend with bread flour if any yeast structure is required.",
      },
    ],
  },
  {
    id: "gluten-free-non-wheat",
    name: "Gluten-free & non-wheat",
    shortName: "GF/non-wheat",
    closestProfile: "Buckwheat",
    summary: "Buckwheat, oat, barley, rice, almond, and other non-standard flours. Many ferment, but most do not make wheat-style dough structure.",
    science: "Fermentation activity and visible rise separate here: a flour can bubble, acidify, and taste great while holding very little gas.",
    records: [
      {
        id: "bobs-buckwheat",
        brand: "Bob’s Red Mill",
        name: "Buckwheat Flour",
        style: "Gluten-free pseudo-grain",
        closestProfile: "Buckwheat",
        protein: "Nutrition-label range",
        ash: "Mineral-rich",
        absorption: "High",
        strength: "No gluten",
        sourceStatus: "Public product/nutrition record",
        sourceUrl: "https://www.bobsredmill.com/product/buckwheat-flour",
        starterEffect: "Can acidify strongly and smell earthy; jar rise is not a good readiness measure.",
        recipeEffect: "Great flavor and fermentation energy, but needs binders or wheat flour for bread structure.",
        adjustment: "Use as a flavor flour or build a dedicated gluten-free binder system.",
      },
      {
        id: "bobs-oat",
        brand: "Bob’s Red Mill",
        name: "Oat Flour",
        style: "Whole oat flour",
        closestProfile: "Oat flour",
        protein: "Nutrition-label range",
        ash: "Whole grain",
        absorption: "High / beta-glucan viscosity",
        strength: "No gluten",
        sourceStatus: "Public product/nutrition record",
        sourceUrl: "https://www.bobsredmill.com/product/oat-flour",
        starterEffect: "Can bubble but usually forms a paste, not a tall starter.",
        recipeEffect: "Softness, sweetness, and moisture; weakens free-form wheat loaves at high percentages.",
        adjustment: "Use modestly and increase water gradually.",
      },
      {
        id: "bobs-barley",
        brand: "Bob’s Red Mill",
        name: "Barley Flour",
        style: "Whole barley flour",
        closestProfile: "Barley",
        protein: "Nutrition-label range",
        ash: "Whole grain",
        absorption: "Very high / beta-glucan",
        strength: "Very low gluten strength",
        sourceStatus: "Public product/nutrition record",
        sourceUrl: "https://www.bobsredmill.com/product/barley-flour",
        starterEffect: "Ferments readily but visible lift stays low.",
        recipeEffect: "Adds sweetness and softness; use as a minority flour for breads.",
        adjustment: "Pair with strong wheat flour or use in pan/quick breads.",
      },
      {
        id: "rice-flour",
        brand: "Generic / Bob’s-style",
        name: "Brown Rice Flour",
        style: "Gluten-free rice flour",
        closestProfile: "Buckwheat",
        protein: "Low-moderate",
        ash: "Whole grain if brown",
        absorption: "Moderate / gritty if underhydrated",
        strength: "No gluten",
        sourceStatus: "Public nutrition-label style record",
        sourceUrl: "https://www.bobsredmill.com/product/brown-rice-flour",
        starterEffect: "Can support gluten-free sourdough cultures but visible rise needs binders.",
        recipeEffect: "Neutral base for GF blends; can be sandy without enough hydration.",
        adjustment: "Hydrate thoroughly and pair with starches/gums/psyllium for structure.",
      },
      {
        id: "almond-flour",
        brand: "Generic / Blue Diamond-style",
        name: "Almond Flour",
        style: "Nut flour",
        closestProfile: "Buckwheat",
        protein: "Nut protein, no gluten",
        ash: "Mineral-rich",
        absorption: "Fat-rich / low water binding",
        strength: "No gluten",
        sourceStatus: "Typical nutrition-label record",
        sourceUrl: "https://www.seriouseats.com/wheat-flour-guide",
        starterEffect: "Not a normal starter feed; little starch for sourdough microbes compared with grain flour.",
        recipeEffect: "Adds fat, tenderness, and nut flavor in cakes and cookies.",
        adjustment: "Do not swap 1:1 for wheat flour in bread formulas.",
      },
    ],
  },
];

export const FLOUR_BRAND_DATABASE = FLOUR_DATABASE_CATEGORIES.flatMap((category) => (
  category.records.map((record) => ({
    ...record,
    categoryId: category.id,
    typeCategory: category.name,
    typeShortName: category.shortName,
    typeSummary: category.summary,
    typeScience: category.science,
    closestProfile: record.closestProfile || category.closestProfile,
    sourceNote: record.sourceStatus,
  }))
));

export const FLOUR_TYPES = FLOUR_PROFILES.map((profile) => profile.name);

const NORMALIZED_FLOUR_LOOKUP = new Map(
  FLOUR_PROFILES.flatMap((profile) => (
    [profile.name, ...profile.aliases].map((name) => [name.toLowerCase(), profile])
  )),
);

export function getFlourProfile(name = "") {
  const normalized = String(name).trim().toLowerCase();
  if (!normalized) return FLOUR_PROFILES[0];
  const exact = NORMALIZED_FLOUR_LOOKUP.get(normalized);
  if (exact) return exact;
  return FLOUR_PROFILES.find((profile) => (
    [profile.name, ...profile.aliases].some((alias) => {
      const value = alias.toLowerCase();
      return normalized.includes(value) || value.includes(normalized);
    })
  )) || {
    ...FLOUR_PROFILES[1],
    name: String(name).trim(),
    aliases: [],
    doughScience: "Custom flour uses neutral wheat assumptions until you choose a known flour profile.",
    starterScience: "Custom flour uses neutral starter assumptions; calibrate it with your own peak logs.",
    watch: "Observe water absorption, gas retention, and peak timing, then rely on your logged results.",
  };
}

export function weightedFlourMetric(blend = [], metric, fallback = 1) {
  if (!blend.length) return fallback;
  const total = blend.reduce((sum, item) => sum + Number(item.percent || 0), 0) || 100;
  return blend.reduce((sum, item) => (
    sum + Number(getFlourProfile(item.type)[metric] || fallback) * Number(item.percent || 0) / total
  ), 0);
}

export function rateLabel(value, low = 0.94, high = 1.07) {
  if (value >= high) return "faster";
  if (value <= low) return "slower";
  return "steady";
}

export function liftLabel(value) {
  if (value >= 1.04) return "strong";
  if (value >= 0.82) return "moderate";
  if (value >= 0.5) return "low";
  return "very low";
}
